import React from "react";
import { Position } from "@xyflow/react";
import classNames from "classnames";
import Styles from "./Nodes.module.scss";
import BaseHandle from "../BaseHandle";

export default function GhostActionNode() {
    return (
        <>
            <BaseHandle type="target" position={Position.Left} id="b" />
            <div className={classNames(Styles["node-container"], Styles["ghost-action-node-container"])} />
        </>
    );
}
